// ./src/components/features/Events/EventModeBadge.tsx
//
// How guests join an event — Save the date / Invite list / Open RSVP / Tickets — as one badge, for every list that shows
// events (All Events' cards and table, Home's upcoming events, Crew events).
// 2026-10-07 (owner): "in the event list / crew events it is unclear what event is this - save the date, open rsvp,
// ticketed, invite - it would be nice to see this info in the list."
// ⓘ A NEUTRAL outline badge on purpose: the lifecycle badge beside it (Draft / Published / Canceled / Completed) owns the
// colours, and the theme folds several colour names into one palette — the icon + label carry the mode.

import React from 'react';
import { Badge, BadgeProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { AppIcon } from '@/components/generic';

import { eventModeMeta } from './eventListHelpers';

export interface EventModeBadgeProps {
  /** The event's `eventMode` (link_rsvp | managed_invites | save_the_date | ticketed). Absent / unknown → nothing. */
  eventMode?: string | null;
  size?: BadgeProps['size'];
}

export const EventModeBadge: React.FC<EventModeBadgeProps> = ({ eventMode, size = 'md' }) => {
  const { t } = useTranslation(['events']);
  const meta = eventModeMeta(eventMode);

  if (!meta) {
    return null;
  }

  return (
    <Badge
      size={size}
      variant="outline"
      color="gray"
      leftSection={<AppIcon iconName={meta.icon} size={13} />}
      style={{ flexShrink: 0 }}
      // A hover hint, not an aria-label: a screen reader reads the mode itself. Same keys as the event's own
      // "How guests join" control, so a translation lands in both.
      title={t('events:guestMode.label', { defaultValue: 'How guests join' })}
    >
      {t(`events:guestMode.${meta.value}`, { defaultValue: meta.label })}
    </Badge>
  );
};
